import { Spacer } from "@faire/web/slate/spacing";
import * as React from "react";

import { ProductBasedCollectionPageWrapper } from "./__internal__/ProductBasedCollectionPageWrapper";

interface IProductBasedCollectionErrorContentProps {
  errorMessage: string;
}

export const ProductBasedCollectionErrorContent: React.FC<
  IProductBasedCollectionErrorContentProps
> = ({ errorMessage }) => {
  return (
    <ProductBasedCollectionPageWrapper data-test-id="collection-error-content">
      <Spacer width={20} />
      {errorMessage}
      <Spacer height="3x" />
    </ProductBasedCollectionPageWrapper>
  );
};
